import { useState } from 'react';
import { currentTheme, toggleTheme } from '../lib/theme';

/** Dark ↔ light switcher. Light is the projector / bright-room presentation theme. */
export function ThemeToggle() {
  const [theme, setTheme] = useState(currentTheme());
  const next = theme === 'dark' ? 'light' : 'dark';
  return (
    <button
      type="button"
      className="btn ghost small theme-toggle"
      title={`Switch to the ${next} theme${next === 'light' ? ' (better on projectors)' : ''}`}
      aria-label={`Switch to the ${next} theme`}
      onClick={() => setTheme(toggleTheme())}
    >
      {theme === 'dark' ? '☀' : '☾'}
    </button>
  );
}
